import {
  notShowRecently,
  queryWindowReminder
} from '@/views/chargingVoucherAgency/common/api.js';

const chargeWindowTypes = [
  // 占位
  '',
  // 车辆类型近期显示弹窗
  'VEHICLE_WINDOW',
  // 企微提示弹窗
  'ENTER_PRISE_REMIND_WINDOW'
];

// 保存弹窗显示周期
export const toSaveWindowReminder = (type, day = 1) => {
  if (!type || !day) return;
  if (typeof type !== 'number' || typeof day !== 'number') return;

  const param = {
    chargeWindowType: chargeWindowTypes[type],
    noShowTime: day
  };
  return notShowRecently(param);
};

// 查询弹窗是否显示
export const toQueryWindowReminder = (type) => {
  if (!type) return;
  if (typeof type !== 'number') return;

  const chargeWindowTypes = [
    // 占位
    '',
    // 车辆类型近期显示弹窗
    'VEHICLE_WINDOW',
    // 企微提示弹窗
    'ENTER_PRISE_REMIND_WINDOW'
  ];

  const param = {
    chargeWindowType: chargeWindowTypes[type]
  };
  return new Promise((resolve, reject) => {
    queryWindowReminder(param).then((res) => {
      resolve(res.data.isShow);
    });
  });
};
